function changeQty(change) {
  const qtyInput = document.getElementById("quantity");
  let current = parseInt(qtyInput.value) || 1;
  current += change;
  if (current < 1) current = 1;
  qtyInput.value = current;
}

function addToCart() {
  const quantity = parseInt(document.getElementById("quantity").value) || 1;
  const variantId = document.getElementById("variant-id").value;

  if (window.KROWN && KROWN.theme && KROWN.theme.cart && typeof KROWN.theme.cart.add === 'function') {
    KROWN.theme.cart.add({
      id: variantId,
      quantity: quantity
    });
  } else {
    // Fallback – klassische Methode (nur für Notfall)
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(() => window.location.href = "/cart");
  }
}

function getNextCutoff() {
  // Feiertage als Set, schnelleres Nachschlagen
  const holidays = new Set([
    '2025-01-01','2025-04-18','2025-04-21','2025-05-01',
    '2026-05-25','2026-06-04','2025-06-19','2025-10-03',
    '2025-11-01','2025-12-25','2025-12-26',
    '2026-01-01','2026-04-03','2026-04-06','2026-05-01','2026-05-14','2026-05-25','2026-06-04','2026-10-03','2026-11-01','2026-12-25','2026-12-26','2027-01-01'
  ]);

  const toLocalISO = (d) =>
    `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  const isHoliday = (d) => holidays.has(toLocalISO(d));

  const now = new Date();
  const cutoff = new Date(now);

  // Stunde abhängig vom ZIELTAG setzen
  const setHour = (d) => {
    const isSaturday = d.getDay() === 6;

    if (isSaturday) {
        d.setHours(5, 0, 0, 0);   // Samstag 05:00
    } else {
        d.setHours(3, 0, 0, 0);   // andere Tage 03:00
    }
};

  setHour(cutoff);
  cutoff.setDate(cutoff.getDate() + 2);
  // Wenn jetzt > Cutoff → auf nächsten Tag
  if (now > cutoff) {
    cutoff.setDate(cutoff.getDate() + 1);
    setHour(cutoff);
  }

  while (
    cutoff.getDay() === 0 ||  // Sonntag
    isHoliday(cutoff)         // Feiertag
) {
    cutoff.setDate(cutoff.getDate() + 1);
    setHour(cutoff);
}


  return cutoff;
}

// Hilfsfunktionen (lokales Datum, keine UTC-Konvertierung)
const holidays = new Set([
  '2025-01-01','2025-04-18','2025-04-21','2025-05-01',
  '2025-05-29','2025-06-09','2025-06-19','2025-10-03',
  '2025-11-01','2025-12-24','2025-12-25','2025-12-26','2025-12-27','2025-12-28','2025-12-29','2025-12-30',
  '2026-01-01','2026-04-03','2026-04-06','2026-05-01','2026-05-14','2026-05-25','2026-06-04','2026-10-03','2026-11-01','2026-12-25','2026-12-26','2027-01-01'
]);
const toLocalISO = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
const isHoliday = d => holidays.has(toLocalISO(d));

// falls du samstags nicht zustellst: deliverOnSaturday = false
function isBusinessDay(d, { deliverOnSaturday = true } = {}) {
  const wd = d.getDay(); // 0=So, 6=Sa
  if (wd === 0) return false;                 // Sonntag nie
  if (!deliverOnSaturday && wd === 6) return false; // Samstag optional
  if (isHoliday(d)) return false;             // Feiertag nie
  return true;
}

function getShippingText(now = new Date(), { deliverOnSaturday = true } = {}) {
  const cutoff = getNextCutoff(); // deine (bereinigte) Cutoff-Funktion
  const delivery = new Date(cutoff);

  // AT = 2 Transittage, sonst 1
  const host = window.location.hostname;
  const isAustria = host.includes('.at');
  const deliveryDays = isAustria ? 2 : 1;

  // Zählt nur echte Werktage (gemäß isBusinessDay)
  let added = 0;
  while (added < deliveryDays) {
    delivery.setDate(delivery.getDate() + 1);
    if (isBusinessDay(delivery, { deliverOnSaturday })) {
      added++;
    }
  }

  // Anzeigeformat
  const dd = String(delivery.getDate()).padStart(2, '0');
  const mm = String(delivery.getMonth() + 1).padStart(2, '0');

  // „morgen“ korrekt ermitteln (Mitternacht-normalisiert)
  const startOf = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const isTomorrow =
    startOf(delivery).getTime() === startOf(new Date(now.getFullYear(), now.getMonth(), now.getDate()+1)).getTime();

  return `Lieferung voraussichtlich ${isTomorrow ? 'morgen' : 'am'} ${dd}.${mm}.`;
}


function startCountdown() {
    const countdownEl = document.getElementById("countdown-timer");
    const deliveryDateEl = document.getElementById("delivery-date");

    function update() {
      const now = new Date();
      const cutoff = getNextCutoff();
      const diffMs = cutoff - now;

      const totalSeconds = Math.max(Math.floor(diffMs / 1000), 0);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const pad = (n) => String(n).padStart(2, '0');

      // Setze Werte
      const dEl = document.getElementById("countdown-days");
      const hEl = document.getElementById("countdown-hours");
      const mEl = document.getElementById("countdown-minutes");
      const sEl = document.getElementById("countdown-seconds");
      const deliveryDateEl2 = document.getElementById("deliverydate");
      
      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(minutes);
      if (sEl) sEl.textContent = pad(seconds);
      
      if (deliveryDateEl2) deliveryDateEl2.textContent = getShippingText(now);

      let countdownText = '';
      if (days > 0) {
        countdownText += `${days} Tag${days > 1 ? 'e' : ''} `;
      }
      countdownText += `${hours} Std. ${minutes} Min. ${seconds} Sek.`;
      
      if (countdownEl) countdownEl.textContent = countdownText;
      if (deliveryDateEl) deliveryDateEl.textContent = getShippingText(now);
      
    }

    update();
    setInterval(update, 1000);
  }

function updateShippingBars() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const host = window.location.hostname;
      const isAustria = host.includes(".at");
      const threshold = isAustria ? 75 : 45;
      const total = cart.total_price / 100;

      document.querySelectorAll('[data-shipping-bar]').forEach(barContainer => {
      const bar = barContainer.querySelector('.shipping-progress-fill') || barContainer.querySelector('#shipping-progress-fill');
      const message = barContainer.querySelector('.shipping-progress-message') || barContainer.querySelector('#shipping-progress-message');

        if (!bar || !message) return;
        
        if (total >= threshold) {
          bar.style.width = '100%';
          message.textContent = '🎉 Glückwunsch! Du hast kostenlosen Versand!';
        } else {
          const percent = (total / threshold) * 100;
          const missing = (threshold - total).toFixed(2).replace('.', ',');
          bar.style.width = `${percent}%`;
          message.textContent = `Nur noch ${missing} € bis zum kostenlosen Versand!`;
        }
      });
    });
}

document.addEventListener("DOMContentLoaded", function () {
  console.log("Shipping Bars gefunden:", document.querySelectorAll('[data-shipping-bar]').length);
  updateShippingBars();
  startCountdown();
  
  // Hook nach „In den Warenkorb“
    const form = document.querySelector("form[action='/cart/add']");
      if (form) {
        form.addEventListener("submit", function () {
          setTimeout(updateShippingBars, 1000); // kleine Verzögerung nach Submit
        });
      }
    document.addEventListener("cart:updated", updateShippingBars);
    // Als Fallback zusätzlich auf +/- Button-Klicks hören
    document.addEventListener("click", function (e) {
      if (
        e.target.closest(".qty-button.qty-plus") ||
        e.target.closest(".qty-button.qty-minus")
      ) {
        setTimeout(updateShippingBars, 600);
      }
      const removeLink = e.target.closest('a[data-href*="/cart/change"]');
      if (removeLink) {
        setTimeout(updateShippingBars, 500);
      }
    });
});